function toTitleCase(word) {
  if (word) {
    return word.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  } else {
    return "N/a";
  }
}

function formatMoney(money) {
  const options = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };
  const formatted = Number(money).toLocaleString("en", options);
  return formatted;
}

export { toTitleCase, formatMoney };
